// src/services/apiTimeouts.js

export const API_TIMEOUTS = Object.freeze({
  standard: 10000,
  ai: 30000,
  aiLong: 45000,
  upload: 60000,
  export: 90000,
});